export const isOnline = async (): Promise<boolean> => {
    let isOnline = navigator.onLine
    if(isOnline) {
        try {
            //extra check to ensure connectivity if the connection is spotty
            const response = await fetch(`https://dotfoods.okta.com/.well-known/openid-configuration`,
            {
                headers: { 'cache-control': 'no-cache' }
            });
    
            isOnline = response?.status == 200;
        }
        catch {
            isOnline = false
        }
    }
    return isOnline
}